/// <amd-module name="Wit/LinkedWorkItemsDropdown/Components/LinkedWorkItemsCommitChanges" />
import * as React from "react";

import { Components } from "VSS/Platform/Layout";

import { IArtifactLink } from "../LinkedWorkItemsService";
import { ArtifactCompleteListener, getCommitArtifactLink, ArtifactLinkNames, getBranchArtifactLink } from "../Util/Artifact";
import { ILinkedWorkItemsDropdownProps, LinkedWorkItemsDropdown } from "./LinkedWorkItemsDropdown";

export interface ICommitChangesContext {
    addPushCompleteListener: (listener: PushCompleteListener) => void;
}

export declare type PushCompleteListener = (push: GitPush, newBranchName?: string) => void | Promise<void>;

export interface GitPush {
    commits: { commitId: string }[];
    repository: { id: string; project: { id: string } };
}

export interface ILinkedWorkItemsCommitChangesProps {
    commitChangesContext: ICommitChangesContext;
}

export class LinkedWorkItemsCommitChanges extends React.Component<ILinkedWorkItemsCommitChangesProps> {
    private artifactListener: ArtifactCompleteListener | undefined;

    public render(): JSX.Element {
        const linkedWorkItemsProps: ILinkedWorkItemsDropdownProps = {
            artifactChangesContext: {
                addArtifactCompleteListener: (listener: (artifactLinks: IArtifactLink[]) => Promise<void> | void): void => {
                    this.artifactListener = listener;
                    this.props.commitChangesContext.addPushCompleteListener(this.linkWorkItems);
                }
            }
        };

        return <LinkedWorkItemsDropdown {...linkedWorkItemsProps} />;
    }

    private linkWorkItems = (push: GitPush, newBranchName?: string): Promise<void> | void => {
        if (this.artifactListener) {
            const projectGuid = push.repository.project.id;
            const repositoryId = push.repository.id;

            const artifactLinks: IArtifactLink[] = [];

            // Add commit artifact link first
            artifactLinks.push(getCommitArtifactLink(projectGuid, repositoryId, push.commits[0].commitId, ArtifactLinkNames.CommitToWorkItem));

            // If commit is made to a new branch, add branch artifact link as well
            if (newBranchName) {
                artifactLinks.push(getBranchArtifactLink(projectGuid, repositoryId, newBranchName, ArtifactLinkNames.BranchToWorkItem));
            }

            return this.artifactListener(artifactLinks);
        }
    };
}

Components.add("WIT.LinkedWorkItemsCommitChanges", LinkedWorkItemsCommitChanges);
